import { css, SerializedStyles } from '@emotion/react';
import React from 'react';

interface RowProps extends React.HTMLProps<HTMLDivElement> {
  css?: SerializedStyles;
  height?: number;
  className?: string;
  isResponsible?: boolean;
}

export const LegacyRow: React.FC<React.PropsWithChildren<RowProps>> = ({
  children,
  height,
  isResponsible,
  css: custom_css,
  className,
}: RowProps) => {
  return (
    <div
      className={className}
      css={css`
        position: relative;
        height: ${!isResponsible && height && height + 'px'};
        min-height: ${isResponsible && height + 'px'};
        ${custom_css}
      `}
    >
      {children}
    </div>
  );
};
